<div class="profile-popup">
 <div class="avatar">
   {{ authService?.userData?.avatar }}
 </div>
  <div class="user-data">
    <div class="name">
      {{ authService?.userData?.firstName }}&nbsp;{{ authService?.userData?.lastName }}
    </div>
    <div class="organisation">
      {{ authService?.organisationData?.displayCustomerNumber }}
    </div>
  </div>
</div>
<div class="toolbar-submenu-container">
  <ul role="menu">
    @for (menuItem of menuItems; track $index) {
      <li role="none" class="mb-1">
        @if (menuItem?.command) {
          <a #menuLink
             [pAutoFocus]="menuItem.autoFocus"
             role="menuitem"
             tabindex="0"
             pRipple
             class="toolbar-submenu-item gap-2"
             [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
             (click)="commandItemClick($event, menuItem)"
             (keydown.enter)="commandItemClick($event, menuItem)"
             (keydown.space)="commandItemClick($event, menuItem)"
             (keydown)="onKeyDown($event, $index)">
            @if (menuItem?.icon) {
              <i [ngClass]="menuItem.icon"></i>
            }
            <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
          </a>
        }
        @if (menuItem?.routerLink) {
          <a #menuLink
             [pAutoFocus]="menuItem.autoFocus"
             role="menuitem"
             tabindex="0"
             pRipple
             class="toolbar-submenu-item gap-2"
             [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
             [routerLink]="menuItem.routerLink"
             (keydown)="onKeyDown($event, $index)">
            @if (menuItem?.icon) {
              <i [ngClass]="menuItem.icon"></i>
            }
            <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
          </a>
        }
        @if (menuItem?.url) {
          <a #menuLink
             [pAutoFocus]="menuItem.autoFocus"
             role="menuitem"
             tabindex="0"
             pRipple
             class="toolbar-submenu-item gap-2"
             [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
             [href]="menuItem?.url"
             [target]="menuItem?.target ? menuItem?.target : null"
             (keydown)="onKeyDown($event, $index)">
            @if (menuItem?.icon) {
              <i [ngClass]="menuItem.icon"></i>
            }
            <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
          </a>
        }
        @if (!menuItem?.routerLink && !menuItem.command && !menuItem?.url) {
          <a #menuLink
             [pAutoFocus]="menuItem.autoFocus"
             role="menuitem"
             tabindex="0"
             pRipple
             class="toolbar-submenu-item gap-2"
             [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
             (click)="itemClick($event, menuItem)"
             (keydown.enter)="itemClick($event, menuItem)"
             (keydown.space)="itemClick($event, menuItem)"
             (keydown)="onKeyDown($event, $index)">
            @if (menuItem?.icon) {
              <i [ngClass]="menuItem.icon"></i>
            }
            <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
          </a>
        }
        <div style="height: 1px"></div>
      </li>
    }
  </ul>
</div>
<p-divider></p-divider>
<div>
  <p-floatlabel class="w-full" variant="on">
    <p-select [(ngModel)]="i18n.activeLanguage"
              inputId="lngselect"
              [options]="i18n.availableLanguages"
              optionLabel="label"
              class="w-full"
              (onChange)="changeLanguage()">
      <ng-template #selectedItem let-selectedOption>
        @if (selectedOption) {
          <div class="flex align-items-center gap-2">
            <img [src]="'images/flags/' + selectedOption.value + '.svg'" width="14px" height="10px" [alt]="selectedOption.label"/>
            <div>
              {{ selectedOption.label }}
            </div>
          </div>
        }
      </ng-template>
      <ng-template let-language #item>
        <div class="flex align-items-center gap-2">
          <img [src]="'images/flags/' + language.value + '.svg'" width="14px" height="10px" [alt]="language.label" />
          <div>{{ language.label }}</div>
        </div>
      </ng-template>
    </p-select>
    <label for="lngselect">{{ i18n?.i18nLng()["SELECTLNG"] }}</label>
  </p-floatlabel>
</div>
<!--
<div class="mt-3">
  <p-floatlabel class="w-full" variant="on">
    <p-select [(ngModel)]="demoDataService.selectedRole"
              inputId="roleselect"
              [options]="demoDataService.availableRoles"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full"
              (onChange)="demoDataService.roleChanged()">
    </p-select>
    <label for="lngselect">{{ i18n?.i18nLng()["SELECTROLE"] }}</label>
  </p-floatlabel>
</div>
-->
<!--
<div class="flex align-items-center mt-3">
  <p-checkbox inputId="mockupservice" [(ngModel)]="mockupServiceChecked" [binary]="true" (onChange)="checkMockupService($event.checked)"></p-checkbox>
  <label for="mockupservice" class="ml-2">use backend</label>
</div>
-->
<!--
<div class="flex align-items-center mt-3">
  <p-checkbox inputId="nodemodata" [(ngModel)]="noDataChecked" [binary]="true" (onChange)="demoDataService.noDemoData.set($event.checked)"></p-checkbox>
  <label for="nodemodata" class="ml-2">no demo data</label>
</div>
-->
